<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
    <g fill="currentColor">
        <path d="M451.538 47.945c11.259 0 15.803 7.836 15.803 13.222h-31.606c0-5.45 4.594-13.222 15.803-13.222Zm13.259 37.405c-2.104 4.088-6.921 6.854-13.142 6.854-11.749 0-16.394-8.38-16.52-15.842H493.5c.163-1.051.592-4.035.592-6.362 0-26.357-18.134-41.238-42.644-41.238-25.837 0-43.906 14.88-43.906 41.237 0 26.552 18.068 41.239 44.058 41.239 25.556 0 37.562-14.074 40.768-25.888h-27.571ZM44.882 87.554c-10.482 0-17.924-7.513-17.924-17.488 0-9.51 6.99-17.488 17.924-17.488 10.936 0 17.921 8.024 17.921 17.488 0 9.612-7.08 17.488-17.921 17.488Zm7.842-57.998c-11.5 0-21.364 5.073-26.452 11.035l-.017-9.48H0V140h27.066v-38.986c6.348 6.835 15.19 9.431 24.13 9.431 26.813 0 39.25-20.265 39.25-40.446 0-24.904-15.975-40.443-37.722-40.443ZM126.538 0H99.362v108.889h27.176V0ZM192.113 31.11v40.445c0 6.131-.843 9.11-3.355 12.081-2.426 2.871-6.233 4.225-10.454 4.225-4.217 0-8.031-1.354-10.458-4.225-2.512-2.972-3.351-5.95-3.351-12.08V31.11h-27.074l.003 42.849c0 12.046 1.842 19.908 7.625 26.59 6.116 7.068 15.458 9.878 24.604 9.878 10.713 0 18.134-4.026 23.263-9.953l.018 8.415h26.254V31.11h-27.075ZM307.455 31.11h-18.501l-20.388 20.754-20.389-20.753h-18.501v18.5L250.43 70l-20.754 20.388v18.501h18.501l20.389-20.753 20.388 20.753h18.501v-18.5l-20.753-20.39 20.753-20.387V31.11ZM357.456 47.945c11.259 0 15.804 7.836 15.804 13.222h-31.606c0-5.45 4.594-13.222 15.802-13.222Zm13.259 37.405c-2.104 4.088-6.921 6.854-13.142 6.854-11.749 0-16.394-8.38-16.519-15.842h58.365c.164-1.051.592-4.035.592-6.362 0-26.357-18.134-41.238-42.644-41.238-25.837 0-43.906 14.88-43.906 41.237 0 26.552 18.069 41.239 44.058 41.239 25.556 0 37.562-14.074 40.768-25.888h-27.572Z"/>
    </g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'PluxeeFull',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 495 140',
    },
  },
};
</script>

<style scoped>
  
</style>